import { ListResult } from '../../../services/dtos/listResult';

export const DEFAULT_DOCUMENTS_TAKE = 1000;
// Due to elastic search limitations we can only request 1000 documents at a time hence why we calculate required number
// of calls to retrieve all documents and then do subsequent calls to retrieve missing documents.
export const fetchAllDocuments = async <FetchResultType, PayloadType>(
  fetchDocuments: (payload: PayloadType) => Promise<ListResult<FetchResultType>>,
  payload: PayloadType
): Promise<ListResult<FetchResultType>> => {
  const documents: ListResult<FetchResultType> = await fetchDocuments(payload);
  const additionalRequiredNumberOfFetches = Math.floor(documents.totalResults / DEFAULT_DOCUMENTS_TAKE);
  const additionalFetches: Promise<ListResult<FetchResultType>>[] = [];
  for (let i = 0; i < additionalRequiredNumberOfFetches; i += 1) {
    // we increment skip by 1000 for every additional fetch
    const additionalRequestPayload = {
      ...payload,
      skip: DEFAULT_DOCUMENTS_TAKE * i,
    };

    additionalFetches.push(fetchDocuments(additionalRequestPayload));
  }
  const resolvedAdditionalFetches = await Promise.all(additionalFetches);
  const mergedDocuments = resolvedAdditionalFetches.reduce(
    (mergedDocuments, nextDocumentsBatch) => mergedDocuments.concat(nextDocumentsBatch.results),
    [...documents.results]
  );

  return {
    totalResults: documents.totalResults,
    results: mergedDocuments,
  };
};
